import React from "react";
import { Helmet } from "react-helmet-async";
import { Card } from "react-bootstrap";

import SignIn from "../../components/auth/SignIn.js";
import Logo from "../../assets/img/r1eventech-logo.png";

const SignInPage = () => (
  <React.Fragment>
    <Card.Body className="text-white">
      <div
        className="text-center"
        id="loginLogo"
      >
        <img
          src={Logo}
          alt="R1 Eventech"
          className="img-fluid"
          width="200"
          height="200"
        />
      </div>
      <h4 className="text-center mt-4 mb-0 text-white">
        Painel Administrativo
      </h4>
      <SignIn />
    </Card.Body>
  </React.Fragment>
);

export default SignInPage;
